const baseStyleControl = {
  w: "100%",
  border: "2px solid",
  borderColor: "mediumEmphasis",
  // color: "white",
  borderRadius: "full",
  _checked: {
    bg: "primary",
    borderColor: "primary",
    color: "surface",
    _before: {
      content: `""`,
      display: "inline-block",
      pos: "relative",
      w: "50%",
      h: "50%",
      borderRadius: "50%",
      bg: "currentColor"
    }
  },
  _disabled: {
    opacity: 0.6
  }
};

const baseStyle = {
  label: {
    userSelect: "none",
    _disabled: { opacity: 0.4 }
  },
  container: {
    _disabled: { cursor: "not-allowed" }
  },
  control: baseStyleControl
};

const sizes = {
  md: {
    control: { w: 7, h: 7 },
    label: { fontSize: "md" }
  }
};

const defaultProps = {
  size: "md"
};

export default {
  baseStyle,
  sizes,
  defaultProps
};
